// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"Table_sectionTitle__AvNsu","wrapper":"Table_wrapper__n6MXg"};